module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Black.9875774f.otf";